import { IProductDelivery } from '../types/orders';
import { displaySuccessNotification } from './displayNudosStandardNotifications';
import { formatSpecs } from './formatSpecs';


export const myCopyText = ({ productInfo }: { productInfo: IProductDelivery }) => {
  const myText = `Nombre: ${productInfo?.name}\nComponentes: ${formatSpecs(productInfo?.pills) || ''}\nSKU: ${
    productInfo.sku
  }\nUnidades: ${productInfo?.unit}`;
  displaySuccessNotification({
    customJSXMessage: <>Información del producto copiada con éxito</>
  });
  return myText;
};
